import React, { useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import apiURL from '../../apiURL';

interface Props {
    contestId: string;
    eventId: string;
    number: number;
    smsStatus: string;
    simulated?: boolean;
    isWinner: boolean;
    onSuccess: () => void;
}

export const ContestWinnerSms = ({
    contestId, eventId, number, smsStatus, simulated = false, isWinner, onSuccess
}: Props) => {
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');

    if (!isWinner) return null;

    const send = async () => {
        if (busy || smsStatus === 'sent' || smsStatus === 'pending' || simulated) return;

        const confirmed = window.confirm(
            `Confirmer la notification du gagnant du ticket n° ${number} ? ` +
            'Sur TEST, aucun SMS réel ne sera envoyé.'
        );
        if (!confirmed) return;

        setBusy(true);
        setMessage('');

        try {
            const token = localStorage.getItem('auth') || '';
            const response = await fetch(
                `${apiURL}/contest-admin/${contestId}/winner-sms`,
                {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        event_id: eventId,
                        number
                    })
                }
            );

            const data = await response.json().catch(() => ({}));
            if (!response.ok) {
                throw new Error(
                    Array.isArray(data.message)
                        ? data.message.join(', ')
                        : data.message || 'Notification impossible.'
                );
            }

            setMessage(
                data.status === 'simulated'
                    ? 'Simulation SMS enregistrée.'
                    : 'SMS envoyé.'
            );
            onSuccess();
        } catch (e: any) {
            setMessage(e.message || 'Erreur SMS.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div>
            <Typography variant="body2">
                Statut : {simulated ? 'Simulé' : smsStatus === 'sent' ? 'Envoyé' :
                    smsStatus === 'pending' ? 'En cours' :
                    smsStatus === 'failed' ? 'Échec' : 'Non envoyé'}
            </Typography>
            <Button
                size="small"
                color="primary"
                variant="outlined"
                disabled={busy || simulated || smsStatus !== 'not_sent'}
                onClick={send}
            >
                {busy ? 'Traitement…' : 'Envoyer le SMS'}
            </Button>
            {message && (
                <Typography variant="caption" display="block">
                    {message}
                </Typography>
            )}
        </div>
    );
};
